
import Vue, { VueConstructor } from "vue";
import KPaginatedAutocomplete from "@/components/crud/fields/KPaginatedAutocomplete.vue";
import { purchaseOrderStatusAutocomplete } from "@/modules/delivery/api/delivery";

export default (
  Vue as VueConstructor<
    Vue & {
      $refs: {
        autocomplete: {
          refresh: () => Promise<unknown>;
        };
      };
    }
  >
).extend({
  name: "PurchaseOrderStatusAutocomplete",
  components: { KPaginatedAutocomplete },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  watch: {
    clientId: {
      handler() {
        this.$refs.autocomplete.refresh();
      },
    },
  },
  methods: {
    autocomplete(data: any) {
      return purchaseOrderStatusAutocomplete(this.clientId, data);
    },
  },
});
